module.exports = __webpack_public_path__ + "static/media/tp.b71f4a60.png";